<template>
  <div class="app-container">
    <div class="topic-list-filter">
      <el-row>
         <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-input @keyup.enter.native="searchChange" class="topic-list-filter-value" placeholder="话题名称" v-model.trim="keywords" clearable size="small" suffix-icon="el-icon-search"></el-input>
          </div>
        </el-col>
         <el-col :span="6">
          <div class="grid-content">
            <el-select class="topic-list-filter-value" placeholder="状态" v-model="status" size="small">
               <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <!-- <el-col :span="6">
          <div class="grid-content">
            <el-select class="topic-list-filter-value" placeholder="是否热门" v-model="isHot" size="small">
              <el-option
                v-for="(item, index) in hotOptions"
                :key="index"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col> -->
        <!-- <el-col :span="6">
          <div class="grid-content">
            <el-select class="topic-list-filter-value" placeholder="话题类型" v-model="topicType" size="small">
              <el-option
                v-for="(item, index) in topicTypeOptions"
                :key="index"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col> -->
        <el-col :span="6">
          <div>
            <el-button class="topic-list-filter-reset" size="small" @click="searchChange">立即筛选</el-button>
            <el-button class="topic-list-filter-search" size="small" @click="searchReset">清除条件</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <basic-container>
      <avue-crud ref="crudItem"
        :page="pageItem"
        :data="tableDictItemData"
        @current-change="currentChangeItem"
        @size-change="sizeChangeItem"
        v-model="form"
        @row-update="handleItemUpdate"
        @row-del="rowItemDel"
        @sort-change="handleSortChangeDictItem"
        :before-open="handleBeforeOpen"
        :option="tableDictItemTopicOption"
        :table-loading="tagManagementTableLoading" >
        <template slot="menuLeft">
          <el-button type="primary" @click="handleAdd" icon="el-icon-plus" size="small" v-if="permissions.topic_add">新增话题</el-button>
        </template>
         <template slot="topicType" slot-scope="scope">
           {{scope.row = this.topicTypeOptions[scope.row].label}}
        </template>
         <template slot="sort" slot-scope="scope">
           {{scope.row.isHot ? scope.row.sort : '-'}}
        </template>
        <template slot-scope="scope" slot="menu">
          <!-- <el-button
            title="复制链接"
            size="mini"
            type="text"
            icon="el-icon-share"
            @click="copyLink(scope.row)">复制链接</el-button> -->
          <el-button
            title="编辑"
            v-if="permissions.topic_edit && scope.row.tagCode !== 'other'"
            size="mini"
            type="text"
            icon="el-icon-edit"
            @click="handleEdit(scope.row, scope.index, scope.done)">编辑</el-button>
          <el-button
            title="删除"
            type="text"
            v-if="permissions.topic_del && scope.row.tagCode !== 'other'"
            icon="el-icon-delete"
            size="mini"
            @click="handleDel(scope.row)">删除</el-button>
          <el-button
            type="text"
            title="下架"
            v-if="permissions.topic_banned && scope.row.status === 1"
            icon="el-icon-download"
            size="mini"
            @click="handleApproveOrReject(scope.row, scope.index)">下架</el-button>
          <el-button
            type="text"
            title="上架"
            v-if="permissions.topic_unBanned && scope.row.status === 2"
            icon="el-icon-upload2"
            size="mini"
            @click="handleApproveOrReject(scope.row, scope.index)">上架</el-button>
          <!-- <el-button
            type="text"
            title="标记热门"
            v-if="permissions.topic_hot && !scope.row.isHot"
            icon="icon-hot"
            size="mini"
            @click="handleHotOrCool(scope.row, scope.index)">标记热门</el-button> -->
          <el-button
            type="text"
            title="取消热门"
            v-if="permissions.topic_cool && scope.row.isHot"
            icon="icon-hot"
            size="mini"
            @click="handleHotOrCool(scope.row, scope.index)">取消热门</el-button>
        </template>
      </avue-crud>
    </basic-container>
  </div>
</template>

<script>
import {
  putItemObj,
  addNewTag,
  delItemObj,
  approveTag,
  rejectTag,
  hotTag,
  coolTag,
  delRelateTagObj,
  fetchRelateItemList,
  addRelationTags,
} from '@/api/basic/topic';
import {
  fetchList,
  fetchItemList,
} from '@/api/basic/tagtype';
import {
  tableDictItemTopicOption,
  hotOptions,
  statusOptions,
  topicTypeOptions,
} from '@/const/crud/basic/tagtype';
import { mapGetters } from 'vuex';
import { VueSelect } from 'vue-select';
import 'vue-select/dist/vue-select.css';
import { debounce } from 'lodash';

export default {
  name: 'tagtype',
  components: {
    'v-select': VueSelect,
  },
  activated: function () {
    this.getDictItemList();
  },
  data() {
    return {
      form: {},
      dictId: 3, // 分类
      status: undefined,
      isHot: undefined,
      topicType: '',
      keywords: '',
      tagCode: '',
      relationKeywords: '',
      dialogFormVisible: true,
      tableData: [],
      tableDictItemData: [],
      page: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 10, // 每页显示多少条
      },
      pageRelationItem: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 10, // 每页显示多少条
      },
      pageItem: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 10, // 每页显示多少条
      },
      pageSelectItem: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
        pages: 0,
      },
      listQuery: {
        current: 1,
        size: 10,
        status: '',
      },
      tableLoading: false,
      tagManagementTableLoading: false,
      tagRelationTableLoading: false,
      tableDictItemTopicOption,
      statusOptions,
      hotOptions,
      topicTypeOptions,
      dialogRelateFormVisible: false,
      tableTagRelationData: [],
      dialogAddRelateFormVisible: false,
      tableAddTagRelationData: {},
      tagTypeList: [],
      searchTagTypeList: [],
      newRelateFrom: {},
      searchRelateForm: {},
      relatedTagIds: [],
      tagList: [],
      selected: [],
      searchSelect: '',
      pageLayout: 'total, prev, pager, next',
      pageRelationItemTagId: '',
      tagItemSort: {
        sortField: 'id',
        sortPolicy: 'desc',
      },
      tagRelationSort: [],
    };
  },
  created() {
    this.getDictItemList();
  },
  mounted: function () {},
  computed: {
    ...mapGetters(['permissions']),
  },
  methods: {
    handleAdd() {
      this.$router.push({path: `/content/topic/add`})
    },
    handleEdit(row, index, done) {
      this.$refs.crudItem.rowEdit(row, index, done)
    },
    handleDel(row) {
      this.$refs.crudItem.rowDel(row)
    },
    copyLink(topic) {
      console.log(topic);
      const url = process.env.VUE_APP_BASIC_PAGE_PATH + `/home/topic/${topic.id}`;
      this.$copyText(url).then(
        res => {
          this.$message({
            showClose: true,
            type: 'success',
            message: '已成功复制'
          })
        },
        err => {
          this.$message({
            showClose: true,
            type: 'error',
            message: '失败'
          })
        }
		  )
    },
    getDictItemList() {
      this.tagManagementTableLoading = true;
      fetchItemList(
        Object.assign(
          {
            current: this.pageItem.currentPage,
            size: this.pageItem.pageSize,
          },
          { type: this.dictId },
          { keywords: this.keywords },
          { status: this.status },
          { isHot: this.isHot },
          { tagCode: this.tagCode },
          { sortField: this.tagItemSort.sortField },
          { sortPolicy: this.tagItemSort.sortPolicy },
          { topicType: this.topicType },

        )
      ).then((response) => {
        const list = response.data.data.records;
        list.forEach(item => {
          if (!item.creator) {
            item.creator = 'system';
          }
        });
        this.tableDictItemData = this.formatData(list);
        this.pageItem.total = response.data.data.total;
        this.tagManagementTableLoading = false;
      });
    },
    getRelateItemList(tagId, typeId) {
      this.dialogRelateFormVisible = true;
      this.tagRelationTableLoading = true;
      fetchRelateItemList(
        {
          current: this.pageRelationItem.currentPage,
          size: this.pageRelationItem.pageSize,
          typeId: typeId,
          keywords: this.relationKeywords,
          sortField: this.tagRelationSort.sortField,
          sortPolicy: this.tagRelationSort.sortPolicy
        },
        tagId
      ).then((response) => {
        this.tableTagRelationData = response.data.data.records;
        this.pageRelationItem.total = response.data.data.total;
        this.tagRelationTableLoading = false;
      });
    },
    handleSortChangeDictItem(val) {
      if (val.prop === "sort") {
        this.tagItemSort.sortField = "sort"
      } else {
        this.tagItemSort.sortField = ""
      }
      // 检查排序方式
      if (val.order === 'ascending') {
        this.tagItemSort.sortPolicy = "asc"
      } else if (val.order === 'descending') {
        this.tagItemSort.sortPolicy = "desc"
      } else {
        this.tagItemSort.sortPolicy = ""
      }
      this.getDictItemList(this.dictId);
    },
    handleSortChangeTagRelation(val) {
      if (val.prop === "sort") {
        this.tagRelationSort.sortField = "sort"
      } else {
        this.tagRelationSort.sortField = ""
      }
      // 检查排序方式
      if (val.order === 'ascending') {
        this.tagRelationSort.sortPolicy = "asc"
      } else if (val.order === 'descending') {
        this.tagRelationSort.sortPolicy = "desc"
      } else {
        this.seatagRelationSortrch.sortPolicy = ""
      }
      this.getRelateItemList(this.pageRelationItemTagId);
    },
    formatHot(item) {
      item.hot = hotOptions.find(x => x.value === item.isHot).label;
    },
    formatShow(item) {
      item.show = this.statusOptions[item.status - 1].label;
    },
    formatData(records) {
      if (Array.isArray(records)) {
        records.forEach((x) => {
          this.formatShow(x);
          this.formatHot(x);
        });
      }
      return records;
    },
    searchReset() {
      this.status = '';
      this.isHot = undefined;
      this.topicType = '';
      this.keywords = '';
      this.tagCode = '';
      this.searchChange();
    },
    searchChange() {
      this.pageItem.currentPage = 1;
      this.getDictItemList(this.dictId);
    },
    searchRelationReset() {
      this.relationKeywords = '';
      this.searchRelateForm.tagTypeId = '';
      this.searchRelateChange();
    },
    searchRelateChange(params) {
      this.pageRelationItem.currentPage = 1;
      this.getRelateItemList(
        this.newRelateFrom.tagId,
        this.searchRelateForm.tagTypeId
      );
    },
    handleApproveOrReject(row, index) {
      switch (row.status) {
        case 1:
          this.handleReject(row, index);
          break;
        case 2:
          this.handleApprove(row, index);
          break;
        default:
          break;
      }
    },
    handleApprove(row, index) {
      this.$confirm(`是否上架 "${row.name}" 话题?`, '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
      .then(function () {
        return approveTag(row.id);
      })
      .then((response) => {
        this.$message({
          message: '操作成功',
          type: 'success',
        });
        if (response.data.data) {
          row.status = 1;
          this.formatShow(row);
        }
      })
      .catch(() => {});
    },
    handleReject(row, index) {
      this.$confirm(`是否下架 "${row.name}" 话题?`, '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(function () {
        return rejectTag(row.id);
      }).then((response) => {
        this.$message({
          message: '操作成功',
          type: 'success',
        });
        if (response.data.data) {
          row.status = 2;
          this.formatShow(row);
        }
      })
      .catch(() => {});
    },
    handleHotOrCool(row, index) {
      if (row.isHot) {
        this.handleCool(row, index);
      } else {
        this.handleHot(row, index);
      }
    },
    handleHot(row, index) {
      this.$prompt(row.name, '设置热门话题', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPlaceholder: '热门话题排序',
        inputPattern: /^\d+$/,
        inputErrorMessage: '排序格式不正确'
      }).then(({ value }) => {
        if (Number(value) > 10000) {
          this.$message({
            showClose: true,
            message: "最大值为10000",
            type: 'error'
          });
        }
        this.tagManagementTableLoading = true;
        return hotTag(row.id, value);
      }).then((response) => {
        this.$message({
          message: '操作成功',
          type: 'success',
        });
        this.getDictItemList();
        this.tagManagementTableLoading = false;
      }).catch(() => {
        this.tagManagementTableLoading = false;
      });
    },
    handleCool(row, index) {
      this.$confirm(`是否确认将 "${row.name}" 取消设置为热门话题?`, '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
      .then(() => {
        this.tagManagementTableLoading = true;
        return coolTag(row.id);
      })
      .then((response) => {
        this.$message({
          message: '操作成功',
          type: 'success',
        });
        this.getDictItemList();
        this.tagManagementTableLoading = false;
      })
      .catch((error) => {
        this.tagManagementTableLoading = false;
      });
    },
    currentChange(val) {
      this.page.current = val;
      this.listQuery.current = val;
      this.getList();
    },
    sizeChange(val) {
      this.page.size = val;
      this.listQuery.size = val;
      this.getList();
    },
    currentChangeItem(val) {
      this.pageItem.current = val;
      this.pageItem.currentPage = val;
      this.getDictItemList(this.dictId);
    },
    sizeChangeItem(val) {
      this.pageItem.size = val;
      this.pageItem.pageSize = val;
      this.getDictItemList(this.dictId);
    },
    currentChangePageRelationItem(val) {
      this.pageRelationItem.currentPage = val;
      this.getRelateItemList(this.pageRelationItemTagId);
    },
    sizeChangePageRelationItem(val) {
      this.pageRelationItem.pageSize = val;
      this.getRelateItemList(this.pageRelationItemTagId);
    },
    handleItemUpdate: function (row, index, done, loading) {
      row.type = this.dictId;
      row.sort = !row.isHot ? 0 : row.sort;
      putItemObj(row)
        .then(() => {
          /** this.tableData.splice(index, 1, Object.assign({}, row)) */
          this.$message({
            showClose: true,
            message: '修改成功',
            type: 'success',
          });
          this.getDictItemList(row.dictId);
          done();
        })
        .catch((error) => {
          loading();
        });
    },
    handleBeforeOpen(done) {
      this.form.dictId = this.dictId;
      done();
    },
    rowItemDel: function (row) {
      var _this = this;
      this.$confirm(`是否确认删除 "${row.name}" 话题?`, '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(function () {
          return delItemObj(row.id);
        })
        .then(() => {
          this.getDictItemList(this.dictId, row.type),
            _this.$message({
              showClose: true,
              message: '删除成功',
              type: 'success',
            });
        })
        .catch(function () {});
    },
    handleRelate(row, index) {
      this.pageItem.currentPage = 1;
      this.tagRelationTableLoading = true;
      this.dialogRelateFormVisible = true;
      this.getRelateItemList(row.id);
      this.newRelateFrom.tagId = row.id;
      this.pageRelationItemTagId = row.id;
      // this.listTagType();
    },
    handleRelateDelete(row, index) {
      var _this = this;
      this.$confirm('是否确认删除数据为"' + row.name + '"的数据项?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(function () {
          return delRelateTagObj(row.relatedId);
        })
        .then(() => {
          this.getRelateItemList(row.tagId);
          _this.$message({
            showClose: true,
            message: '删除成功',
            type: 'success',
          });
        })
        .catch(function () {});
    },
    // 新增关联标签
    addRelatedTag() {
      this.dialogAddRelateFormVisible = true;
      this.listTagType();
    },
    // 查找所有标签类型
    listTagType() {
      fetchList().then((res) => {
        const code = res.data.code;
        const data = res.data.data;
        if (code === 0 && data) {
          this.tagTypeList = data.records;
          this.searchTagTypeList = data.records;
        }
      });
    },
    tagTypeChange(typeId) {
      if (typeId != null) {
        this.newRelateFrom.tagTypeId = typeId;
        this.pageSelectItem.currentPage = 1;
        this.selected = [];
        this.tagList.search = '';
        this.handleCurrentChange(1);
      }
    },
    tagListSearch(search) {
      if (!this.newRelateFrom.tagTypeId) {
        return;
      }
      fetchItemList(
        Object.assign(
          {
            current: this.pageSelectItem.currentPage,
            size: this.pageSelectItem.size,
          },
          { type: this.newRelateFrom.tagTypeId },
          { keywords: search }
        )
      ).then((res) => {
        const code = res.data.code;
        const data = res.data.data;

        if (code === 0 && data) {
          this.tagList = data.records;
          this.pageSelectItem.pages = data.pages;
          this.pageSelectItem.total = data.total;
          if (this.pageSelectItem.total === 0) {
            this.pageLayout = 'total';
          } else {
            this.pageLayout = 'total, prev, pager, next';
          }
        }
      });
    },
    resultFormat(resp) {
      var gridResult = [];
      gridResult.list = resp.data.data.records;
      gridResult.totalRow = resp.data.data.total;
      return gridResult;
    },
    //批量添加关联标签
    addRelationForm() {
      const tagRelations = [];
      this.relatedTagIds = this.selected;
      this.relatedTagIds.forEach((item) => {
        tagRelations.push({
          tagId: this.newRelateFrom.tagId,
          relatedTagId: item.id,
        });
      });
      addRelationTags(tagRelations).then(() => {
        this.newRelateFrom.tagTypeId = '';
        this.pageSelectItem.currentPage = 1;
        this.selected = [];
        this.dialogAddRelateFormVisible = false;
        this.getRelateItemList(this.newRelateFrom.tagId);
      });
    },
    cancelDialog() {
      this.newRelateFrom.tagTypeId = '';
      this.selected = [];
      this.tagList = [];
      this.pageSelectItem.total = '';
      this.pageLayout = 'total';
      this.dialogAddRelateFormVisible = false;
    },
    cancelDialogForm() {
      this.keywords = '';
      this.dialogFormVisible = false;
    },
    cancelDialogRelateForm() {
      this.relationKeywords = '';
      this.searchRelateForm.tagTypeId = '';
      this.dialogRelateFormVisible = false;
    },
    handleCurrentChange(val) {
      this.pageSelectItem.currentPage = val
      fetchItemList(
        Object.assign(
          {
            current: this.pageSelectItem.currentPage,
            size: this.pageSelectItem.size,
          },
          { type: this.newRelateFrom.tagTypeId }
        )
      ).then((res) => {
        const code = res.data.code;
        const data = res.data.data;
        if (code === 0 && data) {
          this.tagList = data.records;
          this.pageSelectItem.pages = data.pages;
          this.pageSelectItem.total = data.total;
          if (this.pageSelectItem.total === 0) {
            this.pageLayout = 'total';
          } else {
            this.pageLayout = 'total, prev, pager, next';
          }
        }
      });
    },
    getTagList: debounce(function() {
      this.tagListSearch(this.searchSelect)
    }, 300),
    search(searchKeywords) {
      this.searchSelect = searchKeywords;
      this.getTagList();
    },
  },
};
</script>

<style lang="scss" scoped>
.topic-list-filter {
  margin: 0 10px;
  /deep/ .el-input__inner {
    border: none;
    font-size: 14px;
  }
  .el-row {
    width: 95%;
  }
  &-label {
    font-size: 14px;
    color: #606266;
    margin-right: 10px;
  }
  &-value {
    width: 96% !important;
  }
  &-search {
    float: right;
    margin-right: 8px;
  }
  &-reset {
    float: right;
    margin-right: 10px;
    border-color: #5383f3;
    color: #5383f3;
  }
}
.pagination {
  display: flex;
  margin: 0.25rem 0.25rem 0;
}
.pagination button {
  flex-grow: 1;
}
.pagination button:hover {
  cursor: pointer;
}
/deep/ .icon-hot {
  width: 12px;
  height: 13px;
  margin-bottom: -2px;
}
/deep/ .v-select.vSelect {
  .vs__dropdown-toggle {
    .vs__selected-options {
      input::placeholder {
        color: #c0c4cc;
        padding-left: 4px;
        font-size: inherit;
      }
    }
    .vs__actions {
      .el-icon-arrow-down {
        color: #c0c4cc;
      }
    }
  }
}
</style>
